import { ApiService } from './../../../api/api.service';
import { API_CALL_ERROR } from './../../../store/action';
import { AppInjector } from './../../../app-injector';
import {
  FETCH_PRODUCTS_REQUESTED,
  FETCH_PRODUCTS_SUCCEEDED,
  FILTER_PRODUCT_REQUESTED,
  FILTER_PRODUCT_SUCCEEDED,
  MAP_CATEGORIES_TO_PRODUCTS,
  FILTER_PRODUCTS_BY_STATUS,
  FETCH_PARTNER_PRODUCT_REQUESTED,
  FETCH_PARTNER_PRODUCT_SUCCEEDED,
  SEND_PRODUCT_TO_PARTNER_QUEUE_REQUESTED,
  BULK_UPDATE_PRODUCT_REQUESTED,
  BULK_UPDATE_PRODUCT_FAILED,
  BULK_UPDATE_PRODUCT_SUCCEEDED,
  BULK_UPDATE_PRODUCT_COMPLETE,
  REINDEX_PRODUCT_REQUESTED,
  REINDEX_PRODUCT_SUCCEEDED,
  STOP_GLOBAL_SALE_REQUESTED, START_GLOBAL_SALE_REQUESTED
} from './list.actions';
import { ADD_HISTORY_SUCCEEDED } from '../product.action';
import { takeEvery, put, select } from 'redux-saga/effects';
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from "../../../common/services/utility/utility.service";
import { PRODUCT_COMP } from "../product.const";
import { DELIVERY_COMP } from "../../delivery/delivery.const";
import { NotificationService } from '../../../common/services/notification/notification.service';
import {COLLECTION_COMP} from "../../collection/collection.const";
import {CREATE_GHOST_PRODUCTS_REQUESTED, CREATE_GHOST_PRODUCTS_SUCCEEDED} from "../ghost/ghost.actions";

function* fetchProducts(action) {
  const api = AppInjector.get(ApiService);
  try {
    if (!action.com || action.com !== COLLECTION_COMP) {
      AppInjector.get(UtilityService).reset();
    }
    let results = yield api.product.get(action.data.pagination, action.data.sort, action.data.filter).toPromise();
    results.items = _.map(results.items, (item) => {
      item.selected = false;
      return item;
    });
    yield put({ type: FETCH_PRODUCTS_SUCCEEDED, data: results.items, pagination: results.pagination });
    yield put({ type: ADD_HISTORY_SUCCEEDED, data: action.data });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchProductRequested() {
  yield takeEvery(FETCH_PRODUCTS_REQUESTED, fetchProducts);
}



function* filterProducts(action) {
  const api = AppInjector.get(ApiService);
  try {
    let results = yield api.product.get(action.data.pagination, action.data.sort, action.data.filter).toPromise();
    if (!_.isUndefined(action.com)) {
      switch (action.com) {
        case DELIVERY_COMP:
          yield put({ type: FILTER_PRODUCT_SUCCEEDED, data: results.items, pagination: results.pagination });
          break;
        case PRODUCT_COMP:
          yield put({ type: FILTER_PRODUCT_SUCCEEDED, data: results.items, pagination: results.pagination });
          break;
        default:
          break;
      }
    } else {
    }
    yield put({ type: ADD_HISTORY_SUCCEEDED, data: action.data });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFilterProductsRequest() {
  yield takeEvery(FILTER_PRODUCT_REQUESTED, filterProducts);
}

function* mapCategoriesToProduct(action) {
  const api = AppInjector.get(ApiService);
  try {
    let categories = yield select(state => (state as any).Category.list.items);
    yield put({ type: MAP_CATEGORIES_TO_PRODUCTS, data: categories });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchProductsSUCCEEDED() {
  yield takeEvery(FETCH_PRODUCTS_SUCCEEDED, mapCategoriesToProduct);
}

function* filterProductsByStatus(action) {
  try {
    const activatedRoute = AppInjector.get(ActivatedRoute);
    const router = AppInjector.get(Router);
    const url = activatedRoute.snapshot.url;
    let queryParams = _.assign({}, activatedRoute.snapshot.queryParams, { page: 1 });
    let status = [];
    status = _.map(action.data.filter(item => item.isChecked === true), i => i.id);
    if (!_.isEmpty(status)) {
      queryParams = _.assign(queryParams, { filter_order_status: status.join(',') });
      router.navigate([url], { queryParams: queryParams });
    } else {
      if (typeof queryParams['filter_order_status'] !== 'undefined') {
        delete queryParams['filter_order_status'];
      }
      router.navigate([url], { queryParams: queryParams });
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFilterOrderByStatus() {
  yield takeEvery(FILTER_PRODUCTS_BY_STATUS, filterProductsByStatus);
}

function* updateMultiProductStatus(action) {
  try {
    const api = AppInjector.get(ApiService);

    AppInjector.get(NotificationService).show('success', 'Update status started', 1000);
    let query = action.data.product_query;
    let result = yield api.product.bulkUpdateProcessStatus({
      sort: query.sort,
      filter: query.filter,
      search: query.pagination.search
    }, action.data).toPromise();
    yield put({ type: BULK_UPDATE_PRODUCT_COMPLETE, data: result.data });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchUpdateMultiProductStatusRequested() {
  yield takeEvery(BULK_UPDATE_PRODUCT_REQUESTED, updateMultiProductStatus);
}

function* UpdateMultiProductStatusFailed(action) {
  AppInjector.get(NotificationService).show('warning', action.message, 5000);
}

function* watchUpdateMultiProductStatusFailed() {
  yield takeEvery(BULK_UPDATE_PRODUCT_FAILED, UpdateMultiProductStatusFailed);
}

function* UpdateMultiProductStatusSuccessed(action) {
  AppInjector.get(NotificationService).show('success', `Successfully import products to collection`, 5000);
}

function* watchUpdateMultiProductStatusSuccessed() {
  yield takeEvery(BULK_UPDATE_PRODUCT_SUCCEEDED, UpdateMultiProductStatusSuccessed);
}

function* sendProductToQueue(action) {
  try {
    const api = AppInjector.get(ApiService);
    const activatedRoute = AppInjector.get(ActivatedRoute);
    const url = activatedRoute.snapshot.url;
    const router = AppInjector.get(Router);
    let queryParams = _.assign({}, activatedRoute.snapshot.queryParams, { page: 1 });

    yield api.product.sendPartnerQueue(action.data).toPromise();
    AppInjector.get(NotificationService).show('success', 'Sent to queue', 5000);
    router.navigate([url], { queryParams: queryParams });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchSendProductToQueue() {
  yield takeEvery(SEND_PRODUCT_TO_PARTNER_QUEUE_REQUESTED, sendProductToQueue);
}

function* getPartners(action) {
  const api = AppInjector.get(ApiService);
  try {
    let results = yield api.product.getPartners().toPromise();
    yield put({ type: FETCH_PARTNER_PRODUCT_SUCCEEDED, data: results });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchGetPartners() {
  yield takeEvery(FETCH_PARTNER_PRODUCT_REQUESTED, getPartners);
}

function* reindexProductsRequested(data) {
  const api = AppInjector.get(ApiService);
  try {
    let result = yield api.elasticsearch.reindexProducts(data.data).toPromise();
    AppInjector.get(NotificationService).show('success', 'Reindex started.. please wait for a while', 5000);
    yield put({ type: REINDEX_PRODUCT_SUCCEEDED, data: result.data });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchReindexProductsRequested() {
  yield takeEvery(REINDEX_PRODUCT_REQUESTED, reindexProductsRequested);
}

function* startGlobalSale() {
  const api = AppInjector.get(ApiService);
  try {
    yield api.product.startGlobalSale().toPromise();
    AppInjector.get(NotificationService).show('success', 'Starting sale..', 5000);
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchStartGlobalSaleRequested() {
  yield takeEvery(START_GLOBAL_SALE_REQUESTED, startGlobalSale);
}

function* stopGlobalSale() {
  const api = AppInjector.get(ApiService);
  try {
    yield api.product.stopGlobalSale().toPromise();
    AppInjector.get(NotificationService).show('success', 'Stopping sale..', 5000);
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchStopGlobalSaleRequested() {
  yield takeEvery(STOP_GLOBAL_SALE_REQUESTED, stopGlobalSale);
}

export default [
  watchFilterOrderByStatus,
  watchFetchProductRequested,
  watchFilterProductsRequest,
  watchFetchProductsSUCCEEDED,
  watchUpdateMultiProductStatusRequested,
  watchSendProductToQueue,
  watchGetPartners,
  watchUpdateMultiProductStatusSuccessed,
  watchUpdateMultiProductStatusFailed,
  watchReindexProductsRequested,
  watchStartGlobalSaleRequested,
  watchStopGlobalSaleRequested
];
